import React, { createContext, useContext, useState, useEffect } from 'react';
import apiService from '../services/api';

const CompanyContext = createContext();

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (context === undefined) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCompanyInfo = async () => {
    try {
      setLoading(true);
      const response = await apiService.getCompanyPublicInfo();
      if (response.success && response.company) {
        setCompany(response.company);
      } else {
        // If no company is configured, use default values
        setCompany({
          name: 'AutoShop Pro',
          logo: null,
          address: null
        });
      }
    } catch (error) {
      // Check if it's a 404 (company not found) or authentication error
      if (error.message === 'Company not found' || error.message === 'Failed to fetch company information') {
        // Fallback to default company name for 404
        setCompany({
          name: 'AutoShop Pro',
          logo: null,
          address: null
        });
      } else {
        console.error('Error fetching company info:', error);
        // For other errors, still fallback to default
        setCompany({
          name: 'AutoShop Pro',
          logo: null,
          address: null
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyInfo();
  }, []);

  const updateCompany = (updatedCompany) => {
    setCompany(updatedCompany);
  };

  const value = {
    company,
    loading,
    fetchCompanyInfo,
    updateCompany
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};